import React from 'react';

// components
import RichTextInputBox from '../../../components/elements/forms/RichTextInputBox';
import ButtonComponent from '../../../components/elements/forms/ButtonComponent';
import PreviewOrderModal from './PreviewOrderModal';

// types
import { ErrorWarning } from '../../../store/types/misc';
// import CustomAutoComplete from '@/components/elements/forms/CustomAutoComplete';

type IOrderDataType = {
  onPress: (res: string) => void;
  pretest_question?: string;
  assessment_question?: string;
  previewData?: any;
};

const Description: React.FC<IOrderDataType> = ({ onPress, previewData }) => {
  const [data, dataSet] = React.useState<string>('');
  const [err, errSet] = React.useState<ErrorWarning>('');
  const [showPreview, setShowPreview] = React.useState(false);

  const onSubmitEvent = () => {
    if (data.length < 3) {
      errSet('warning');
      return;
    }
    onPress(data);
  };

  return (
    <div className="md:flex flex-col flex justify-center text-left">
      <div className="w-full">
        <RichTextInputBox
          value={data}
          status={err}
          label="Job Description"
          placeholder="Job Description"
          required={true}
          onChange={(res: string) => {
            dataSet(res);
            errSet('');
          }}
        />
      </div>

      <div className="flex items-center justify-end gap-4 my-10">
        <div className="w-[30%]">
          <ButtonComponent
            title="Preview"
            textColor="white"
            backgroundColor="#6B7280"
            active={true}
            onHandler={() => setShowPreview(true)}
          />
        </div>
        <div className="w-[30%]">
          <ButtonComponent
            title="Next"
            textColor="white"
            backgroundColor="#243677"
            onHandler={onSubmitEvent}
            active={true}
          />
        </div>
      </div>

      <PreviewOrderModal
        visible={showPreview}
        onClose={() => setShowPreview(false)}
        data={previewData || {}}
      />
    </div>
  );
};

export default Description;
